(() => {
  if (window.brioPageNavigationBound) return;
  window.brioPageNavigationBound = true;
  let pending;

  const prepare = async (next, base) => {
    const tasks = [];
    const temporary = [];
    // Preload without applying the next page's CSS to the current page.
    next.querySelectorAll('link[rel="stylesheet"],link[rel="preload"][as="font"]').forEach(link => {
      if (link.rel === 'stylesheet' && link.media === 'print') return;
      const href = new URL(link.getAttribute('href'), base).href;
      if (!/\/assets\/brio-[^/]+\.(css|woff2)(?:\?|$)/.test(href)) return;
      if ([...document.querySelectorAll('link[rel="stylesheet"],link[rel="preload"][as="font"]')].some(current => current.href === href)) return;
      tasks.push(new Promise(resolve => {
        const preload = document.createElement('link');
        preload.rel = 'preload';
        preload.as = link.as === 'font' ? 'font' : 'style';
        preload.href = href;
        if (preload.as === 'font') { preload.type = 'font/woff2'; preload.crossOrigin = 'anonymous'; }
        preload.onload = preload.onerror = resolve;
        temporary.push(preload);
        document.head.append(preload);
      }));
    });
    const sources = new Set();
    next.querySelectorAll('link[rel="preload"][as="image"]').forEach(link => {
      if (!link.media || matchMedia(link.media).matches) sources.add(link.getAttribute('href'));
    });
    next.querySelectorAll('.pdp-studio.is-active .pdp-studio-can,main img[fetchpriority="high"]').forEach(image => {
      // The responsive hero preload already chose its mobile/desktop source.
      if (!image.closest('.pdp-photo,.brio-hero-video-poster')) sources.add(image.getAttribute('src'));
    });
    [...sources].filter(Boolean).slice(0, 4).forEach(source => {
      tasks.push(new Promise(resolve => {
        const image = new Image();
        image.onload = () => image.decode().catch(() => {}).then(resolve);
        image.onerror = resolve;
        image.src = new URL(source, base).href;
      }));
    });
    let timer;
    await Promise.race([Promise.all(tasks), new Promise(resolve => { timer = setTimeout(resolve, 1500); })]);
    clearTimeout(timer);
    temporary.forEach(link => link.remove());
  };

  document.addEventListener('click', async event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const target = new URL(link.href, location.href);
    if (target.origin !== location.origin || !/^\/(?:(?:en|it|es)\/?)?(?:(?:products|pages|collections|blogs)(?:\/|$)|$)/.test(target.pathname)) return;
    if (target.pathname === location.pathname && target.search === location.search) return;
    // Product-to-product swaps and locale forms retain their existing handlers.
    event.preventDefault();
    pending?.abort();
    const controller = new AbortController();
    pending = controller;
    link.setAttribute('aria-busy', 'true');
    const timeout = setTimeout(() => controller.abort(), 5000);
    try {
      const response = await fetch(target.href, {credentials:'same-origin', headers:{Accept:'text/html'}, signal:controller.signal});
      if (!response.ok) throw new Error('Page unavailable');
      const resolved = new URL(response.url);
      if (resolved.origin !== location.origin) throw new Error('External redirect');
      const next = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (!next.querySelector('main#MainContent')) throw new Error('Unexpected page');
      await prepare(next, resolved.href);
      if (pending !== controller) return;
      resolved.hash = target.hash;
      location.assign(resolved.href);
    } catch (_) {
      if (pending === controller) location.assign(target.href);
    } finally {
      clearTimeout(timeout);
      link.removeAttribute('aria-busy');
    }
  });
})();
